let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jFTIS")).then(() => parcelRequire('4GOAp'));